import React from 'react';

const formatVirtualNumbersOptions = (numbers, isRtl, title) => {
  const ltrMark = (!isRtl) ? <span>&lrm;</span> : '';
  return (numbers || []).map((item) => {
    const label = <span>{item.ext_target_name}{ltrMark}&nbsp;-&nbsp;{item.virtual_number}&nbsp;{title}</span>;
    return {
      label,
      value: item.virtual_number,
      name: item.ext_target_name,
      realtor_id: item.realtor_id
    };
  });
};

export const formatVirtualNumbersOnlyOptions = (numbers) => numbers.map((item) => {
    const label = <span>{item.ext_target_name}</span>;
    return {
      label,
      value: item.virtual_number,
      name: item.ext_target_name
    };
  });

export default formatVirtualNumbersOptions;
